import React, { useState, useEffect } from "react"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import Card from "../../../components/atoms/Card.atom"
import FieldContainer from "../../../components/layouts/containers/FieldContainer.container"
import InputTextForm from "../../../components/molecules/InputTextForm.molecule"
import QuestionRenderer from "../components/QuestionRenderer"
import { QUESTION_TYPES } from "../../../consts/modules/survey.consts"

export function SurveyBody({
  survey,
  answers,
  updateAnswer,
  onSubmit,
  loading = false,
  isSubmitted,
}) {
  const requiredErrorText = "obligatoria"
  const [clientName, setClientName] = useState(
    () => localStorage.getItem("surveyClientName") || ""
  )


  const [nameError, setNameError] = useState("")
  const [validationErrors, setValidationErrors] = useState({})

  const validateRequiredQuestions = () => {
    const errors = {}
    let hasErrors = false

    survey.questions.forEach((question) => {
      if (question.isRequired) {
        const answer = answers[question.questionId]
        switch (question.typeName) {
          case QUESTION_TYPES.RADIO:
            if (!answer || !answer.value) {
              errors[question.questionId] = requiredErrorText
              hasErrors = true
            }
            break

          case QUESTION_TYPES.TEXT:
            if (!answer || !answer.text || answer.text.trim() === "") {
              errors[question.questionId] = requiredErrorText
              hasErrors = true
            }
            break

          default:
            if (!answer || Object.keys(answer).length === 0) {
              errors[question.questionId] = requiredErrorText
              hasErrors = true
            }
        }
      }
    })

    setValidationErrors(errors)
    return !hasErrors
  }

  const validateContactInfo = () => {
    const errors = { name: "" }
    let hasErrors = false

    if (!clientName || clientName.trim() === "") {
      errors.name = "Este campo es obligatorio"
      hasErrors = true
    }

    setNameError(errors.name)

    return !hasErrors
  }

  const handleSubmitClick = () => {
    const isContactValid = validateContactInfo()
    const areQuestionsValid = validateRequiredQuestions()

    if (isContactValid && areQuestionsValid) {
      localStorage.setItem("surveyClientName", clientName)
      const payload = {
        clientName,
        surveyId: survey.surveyId,
        answers: Object.entries(answers).map(([questionId, answer]) => {
          if (answer.value !== undefined) {
            return {
              questionId: Number(questionId),
              questionOptionId: answer.value,
            }
          } else if (answer.text !== undefined) {
            return {
              questionId: Number(questionId),
              answerText: answer.text,
            }
          } else {
            return { questionId: Number(questionId) }
          }
        }),
      }
      onSubmit(payload)
    } else {
      const firstError = document.querySelector(
        ".error-border, .border-red-500"
      )
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" })
      }
    }
  }

  useEffect(() => {
    if (isSubmitted) {
      const container = document.querySelector(".layout-main-content")
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    }
  }, [isSubmitted])

  return isSubmitted ?
      <Card className="p-6 text-center survey-success-card w-full">
        <h2 className="font-cairo font-bold survey-success-title">
          Encuesta contestada
        </h2>

        <p className="mt-2 survey-success-text">
          Gracias por contestar la encuesta, tus comentarios nos ayudan a
          mejorar.
        </p>
      </Card>
    : <div className="survey-body">
        <Card className="mb-4 survey-question-card survey-question-content">
          <div className="mb-3">
            <span className="survey-contact-title font-mulish">
              Por favor ingresa tus datos de contacto
            </span>
          </div>
          <FieldContainer
            col={12}
            className="w-full md:flex-1 mb-0 p-0 font-mulish survey-question-text"
          >
            <InputTextForm
              label="Nombre"
              name="clientName"
              onChange={(e) => {
                setClientName(e.target.value)
                setNameError("")
              }}
              value={clientName}
              autoComplete="name"
              error={nameError ? [{ errorMessage: nameError }] : []}
              className={nameError ? "error-border" : ""}
            />
          </FieldContainer>
        </Card>

        {survey.questions
          .sort((a, b) => a.questionOrder - b.questionOrder)
          .map((question) => (
            <Card
              key={question.questionId}
              className="w-full survey-question-card"
            >
              <div className="survey-question-content">
                <QuestionRenderer
                  question={question}
                  value={answers[question.questionId] || {}}
                  updateAnswer={updateAnswer}
                  error={validationErrors[question.questionId]}
                  onClearError={() => {
                    setValidationErrors((prev) => ({
                      ...prev,
                      [question.questionId]: null,
                    }))
                  }}
                />
              </div>
            </Card>
          ))}

        <div className="survey-submit-container">
          <PrimaryButton
            label="Enviar respuesta"
            icon={`pi ${loading ? "pi-spin pi-spinner" : "pi-arrow-right"}`}
            iconPos="right"
            rounded
            disabled={loading}
            onClick={handleSubmitClick}
          />
        </div>
      </div>
}
